<nav class="navbar navbar-expand-lg py-2">
  <div class="container-fluid d-flex py-2 justify-content-between align-items-center">

    <!-- Brand Logo -->
    <a class="navbar-brand" routerLink="/">
      <img src="../../../assets/img/new/frost’n-crunch.png" class="logo ms-3" alt="Logo" />
    </a>

    <!-- Desktop Profile Icon -->
<div class="d-none d-lg-flex align-items-center">
  <i
    class="bi bi-box-arrow-in-right px-3 fs-3"
    role="button"
    tabindex="0"
    [routerLink]="['/login']"
    aria-label="Login"
  ></i>
</div>


    <!-- Mobile Toggle -->
    <button class="navbar-toggler d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar">
      <i class="bi bi-list fs-3"></i>
    </button>
  </div>

  <!-- Offcanvas for Mobile -->
  <div class="offcanvas offcanvas-end d-lg-none" tabindex="-1" id="offcanvasNavbar">
    <div class="offcanvas-header">
      <img src="../../../assets/img/new/frost’n-crunch.png" class="mobile-logo" alt="Logo" />
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
    </div>
    <div class="offcanvas-body">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link josefin-sans-semibold" [routerLink]="['/login']">Login</a>
        </li>
        <!-- Add more nav items here if needed -->
      </ul>
    </div>
  </div>
</nav>
